import { RoundOption } from "./RoundOption.tsx";
import styles from "./TaxClassSelect.module.css";

import type { JSX } from "react";

type TaxClassSelectProps = {
  name: string;
  id: string;
  value?: number;
  onValueChanged?: (value: number) => void;
  ariaLabelledBy?: string;
};

const TaxClassSelect = (props: TaxClassSelectProps): JSX.Element => {
  const { id, name, value = 1, onValueChanged, ariaLabelledBy } = props;

  const onChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    if (onValueChanged) {
      onValueChanged(parseInt(evt.target.value));
    }
  };
  return (
    //TODO div cannot be labelled, this should be a proper control => FieldSet with Legend
    <div className={styles.taxClass} id={id} role="radiogroup" aria-labelledby={ariaLabelledBy}>
      <RoundOption name={name} value={1} selected={value === 1} onChange={onChange} />
      <RoundOption name={name} value={2} selected={value === 2} onChange={onChange} />
      <RoundOption name={name} value={3} selected={value === 3} onChange={onChange} />
      <RoundOption name={name} value={4} selected={value === 4} onChange={onChange} />
      <RoundOption name={name} value={5} selected={value === 5} onChange={onChange} />
      <RoundOption name={name} value={6} selected={value === 6} onChange={onChange} />
    </div>
  );
};

export { TaxClassSelect };
